import React from 'react';
import AppRoutes from './routers/AppRoutes';
import NotificationViewer from './components/notifications/NotificationViewer';
// import { requestNotificationPermission } from './services/notificationService';

const App = ({ toggleTheme, isDarkMode }) => {
    // useEffect(() => {
    //     // Solicitar permisos de notificación al cargar la aplicación
    //     requestNotificationPermission();
    // }, []);

    return (
        <>
            <AppRoutes toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
            <NotificationViewer />
        </>
    );
};

export default App;